import React, { Component } from 'react'
import { 
  Col, 
  Row
} from 'reactstrap'
import { connect } from 'react-redux'
import Slider from "react-slick"
import _ from 'lodash'

import TemplateContainerMain from 'Template/main'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import InputEmail from './InputEmail'
import InputPassword from './InputPassword'

import bg1 from 'assets/TemplateImages/media/start_ziel_03_.jpg'

import WithPassword from './actions'
import { ApplyBranding } from 'utils/apply-color'

const SliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  initialSlide: 0,
  autoplay: true,
  adaptiveHeight: true
}

const SliderImageItemStyle = { 
  opacity: "0.4", 
  height: "100vh", 
  minHeight: "100vh",
  width: "100%",
  objectFit: "cover",
  objectPosition: "center" 
}

class ForgetPassword extends Component {
  state = {
    email: '',
    password: '',
    confirmPassword: ''
  }

  componentDidMount = () => {
    if( !_.isEmpty( this.props.match.params ) ){
      this.props.onChangePasswordHOC( 'token', this.props.match.params.resetPasswordToken )
    } else {
      this.props.onChangePasswordHOC( 'token', '' )
    }
  }

  handleRedirectLink = ( contentType ) => {
    if( window.location.host.indexOf( 'localhost' ) > -1 || window.location.host.indexOf( 'cockpit-staging.aciso-suite.com' ) > -1 || window.location.host.indexOf( 'adminportal.aciso-suite.com' ) > -1 ) {
      return `https://www.aciso.com/${ contentType }`
    } else if( window.location.host.indexOf( 'adminportal.tennis-suite.com' ) > -1 ) {
      return `https://www.tennis-people.com/${ contentType }`
    } else if( window.location.host.indexOf( 'adminportal.proof-point-suite.com' ) > -1 ) {
      return `https://www.proof-point.com/${ contentType }`
    }
  }

  render = () => {
    return (
      <>
        {
          !_.isEmpty( this.props.data.platformConfigReducer.platformConfig ) 
          && _.find( this.props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_COLOR' } )
          && <ApplyBranding colors={{ primary: _.find( this.props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_COLOR' } ).value }} />
        }
        <TemplateContainerMain>
          <div style={{ height: "100vh" }} >
            <Row className="no-gutters" style={{ height: "100vh" }}>
              <Col lg="4" className="d-none d-lg-block">
                <div className="slider-light">
                  <Slider { ...SliderSettings }>
                    <div
                      className="d-flex justify-content-start align-items-start bg-plum-plate">
                      <img 
                        src={ bg1 } 
                        style={ SliderImageItemStyle } />
                    </div>
                  </Slider>
                </div>
              </Col>
              <Col 
                lg="8" 
                md="12" 
                style={{ height: "100vh", overflow: "scroll" }}
                className="d-flex bg-white justify-content-center align-items-center" >
                <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
                  <img 
                    src={
                      !_.isEmpty( this.props.data.platformConfigReducer.platformConfig ) 
                      && _.find( this.props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_ICON' } ) 
                        ? _.find( this.props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_ICON' } ).value
                        : ''
                    }
                    style={{ width: '150px', marginBottom: '0' }}/>
                  <h4 className="mb-0">
                    <div>Brauchen Sie Hilfe mit Ihrem Passwort?</div>
                    <span>Geben Sie Ihre E-Mail-Adresse ein und wir helfen Ihnen mit Ihrem neuen Passwort.</span>
                  </h4>
                  <Row className="divider"/>
                  {
                    this.props.token === '' && (
                      <InputEmail
                        success={ this.props.success }
                        error={ this.props.error }
                        email={ this.state.email }
                        sendEmailPasswordReset={ this.props.sendEmailPasswordReset }
                        onChangeEmail={ val => this.setState({ email: val }) }
                        history={ this.props.history } />
                    )
                  }
                  {
                    this.props.token !== '' && (
                      <InputPassword
                        success={ this.props.success }
                        error={ this.props.error }
                        password={ this.state.password }
                        confirmPassword={ this.state.confirmPassword }
                        token={ this.props.token }
                        onChangePassword={ val => this.setState({ password: val }) }
                        onChangeConfirmPassword={ val => this.setState({ confirmPassword: val }) }
                        sendPassword={ this.props.sendPassword }
                        history={ this.props.history } />
                    )
                  }
                </Col>
                <div style={{ position: 'fixed', bottom: '30px', fontSize: '17px' }}>
                  <a href={ this.handleRedirectLink( 'impressum' ) } target="_blank" className='mr-3'>Impressum</a>
                  <a href={ this.handleRedirectLink( 'datenschutz' ) } target="_blank">Datenschutz</a>
                </div>
              </Col>
            </Row>
          </div>
          { this.props.onLoadPassword && <LoadingOverlay /> }
        </TemplateContainerMain>
      </>
    )
  }
}

const mapStateToProps = state => ({ data: state })

export default connect( mapStateToProps )( 
  WithPassword( ForgetPassword )
)